import React from 'react';
import './past-due-badge.scss';

export default class PastDueBadge extends React.PureComponent {
  render() {
    return (
      <span className='past-due-badge'>
        <span className='past-due-badge__icon fa fa-exclamation-triangle' />
        <span className='past-due-badge__text'>Past due</span>
      </span>
    );
  }
}
